export default class GerarSegundaViaBoletoSienge {
    receivableBillId: number;
    installmentId: number;

    constructor(
        receivableBillId: number,
        installmentId: number
    ) {
        this.receivableBillId = receivableBillId;
        this.installmentId = installmentId;
    }
}